module.exports = __webpack_public_path__ + "img/我的流量.ac077c27.png";